/**
 * Component template (Do not modify or delete this file – only copy)
 */
 var component_timeline = function(args) {
  // setup args
  var timeline = args.timeline;
  // the actual timeline of the timeline element
  var timeline_timeline = timeline.querySelector('.timeline__timeline');

  // next and previous buttons
  var controls = timeline.querySelectorAll('.timeline__control-button');

  // get data-year attribute from slides
  var years = [...timeline.querySelectorAll('.timeline__slide')].map((slide) => slide.dataset.year);

  // timeline years
  var timeline_years = timeline.querySelector('.timeline__timeline__wrap');

  // validate
  if (!timeline) {
    console.log('Invalid timeline component');
    return;
  }

  /**
   * Calculate and set the timeline slides next and previous button placement
   *
   * @param {NodeList} controls
   */
  function set_controls_position(controls) {
    let img = timeline.querySelector('.swiper-slide-active img');
    controls.forEach(control => {
      control.style.top = img.offsetHeight / 2 + 'px';
    });
  }

  /**
   * Move the timeline by calculating the needed offset from the current bullet
   */
  function move_timeline(bullet) {
    timeline_years.style.transform = `translate3d(calc(50% - ${bullet.offsetLeft + bullet.offsetWidth / 2}px),0,0)`;
  }

  /**
   * Set an explicit height for the timeline to prevent a bouncing effect when changing the slide
   */
  function set_timeline_height() {
    timeline_timeline.style.height = `${timeline_timeline.offsetHeight}px`;
  }

  /**
   * Init
   */
  function init_timeline() {

    const timeline_slides = new Swiper(timeline.querySelector('.timeline__slides__wrap'), {
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.timeline__timeline__wrap',
        clickable: true,
        renderBullet: function (index, className) {
          return `
            <span class="${className} timeline__bullet">
              <span class="timeline__bullet__year">
                ${years[index]}
              </span>
            </span>
          `;
        },
      }
    });

    setTimeout(() => {
      // get pagination bullets (years)
      let timeline_bullets = timeline.querySelectorAll('.swiper-pagination-bullet');

      // add click event listeners to bullets
      timeline_bullets.forEach(bullet => {
        bullet.addEventListener('click', () => move_timeline(bullet));
      });

      // move timeline when changing the slide
      timeline_slides.on('slideChange', (e) => {
        move_timeline(timeline_bullets[e.activeIndex]);
      });
    }, 0);

    set_controls_position(controls);
    set_timeline_height();

    let window_resize = debounce(() => {
      set_controls_position(controls);
      set_timeline_height();
    }, 250);
    window.addEventListener('resize', window_resize);

    return;
  }

  init_timeline();

  // make the call chainable
  return this;
};
